import type {
  MentorProfileDraft,
  MentorProfileReview,
} from "@/lib/api/mentor-profile";

const STORAGE_KEY = "mock-mentor-profile-review";

const seedReview = (): MentorProfileReview => {
  const now = new Date().toISOString();
  return {
    id: "mock-review",
    mentor_id: "mock-mentor",
    status: "in_progress",
    draft: {
      first_name: "Jordan",
      last_name: "Rivera",
      display_name: "",
      email: "jordan.rivera@gmail.com",
      phone: "4155550188",
      birthday: "1999-04-12",
      sex: "Female",
      gender_identity: "Woman",
      pronouns: "she/her",
      race: "Hispanic or Latino",
      languages: [],
      bio: "",
    },
    published_snapshot: null,
    change_requests: [],
    furthest_step: null,
    submitted_at: null,
    reviewed_at: null,
    reviewed_by: null,
    review_comment: null,
    invite_sent_at: now,
    created_at: now,
    updated_at: now,
  };
};

export const getMockReview = (): MentorProfileReview => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return JSON.parse(stored) as MentorProfileReview;
  } catch {
    localStorage.removeItem(STORAGE_KEY);
  }
  const seeded = seedReview();
  localStorage.setItem(STORAGE_KEY, JSON.stringify(seeded));
  return seeded;
};

export const patchMockDraft = (
  patch: Partial<MentorProfileDraft>,
  furthestStep?: string,
): MentorProfileReview => {
  const current = getMockReview();
  const next: MentorProfileReview = {
    ...current,
    draft: { ...current.draft, ...patch },
    furthest_step: furthestStep ?? current.furthest_step,
    updated_at: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  return next;
};

export const submitMockReview = (): MentorProfileReview => {
  const current = getMockReview();
  if (current.status === "submitted" || current.status === "in_review") {
    return current;
  }

  const now = new Date().toISOString();
  const next: MentorProfileReview = {
    ...current,
    status: "submitted",
    published_snapshot: current.published_snapshot,
    change_requests: current.change_requests.map((c) => ({
      ...c,
      status: "resolved",
    })),
    submitted_at: now,
    updated_at: now,
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  return next;
};
